import { render, staticRenderFns } from "./ScaleQuestion.vue?vue&type=template&id=1e073536"
import script from "./ScaleQuestion.vue?vue&type=script&lang=js"
export * from "./ScaleQuestion.vue?vue&type=script&lang=js"
import style0 from "./ScaleQuestion.vue?vue&type=style&index=0&id=1e073536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports